var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_5968830",
    clipPath: "url(#clip0_5191_13309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3361 12.0728L18.962 20.1199H16.6531L12.0623 13.5535V13.5531L11.3883 12.5891L6.02539 4.91797H8.33427L12.6621 11.1089L13.3361 12.0728Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.2987 0H2.7013C1.20945 0 0 1.20945 0 2.7013V22.2987C0 23.7905 1.20945 25 2.7013 25H22.2987C23.7905 25 25 23.7905 25 22.2987V2.7013C25 1.20945 23.7905 0 22.2987 0ZM15.9458 21.2005L11.3001 14.4393L5.4837 21.2005H3.98044L10.6326 13.4682L3.98044 3.78667H9.0542L13.4533 10.1891L18.9611 3.78667H20.4643L14.121 11.1603H14.1206L21.0196 21.2005H15.9458Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5191_13309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8618773d3a9d25153a1c159d97e217a4.svg";
export { ForwardRef as ReactComponent };